import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CustomCursor from './CustomCursor';
import ScrollProgress from './ScrollProgress';

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <>
      {/* Render Header only if not on the Certificates page */}
      {location.pathname !== '/certificates' && <Header />}
      <main>
        <Outlet />
      </main>
      <CustomCursor />
      <ScrollProgress />
      <Footer />
    </>
  );
}

